import type { Tag } from 'aqTypes';
import type { ComponentTypeValue } from './ComponentTypeValue';
import type { FieldValue } from './FieldValue';
import type { DiffType } from '@ardoq/data-model';
import type {
  ComponentDataModel,
  GraphItemDestroyOptions,
} from './graphItemTypes';
import {
  APIReferenceAttributes,
  APITagAttributes,
  APIWorkspaceAttributes,
} from '@ardoq/api-types';

export abstract class GraphItem<TModel = GraphItemModel> {
  abstract id: string;
  abstract getLabel(): string;
  abstract hasURLFields(): boolean;
  abstract dataModel: TModel;
  abstract destroy(options: GraphItemDestroyOptions): void;
  abstract getVisualDiffType: () => DiffType;
}

export type NamedGraphItemModel =
  | ComponentDataModel
  | APIReferenceAttributes
  | APITagAttributes
  | APIWorkspaceAttributes
  | FieldValue
  | ComponentTypeValue
  | Tag;
export type GraphItemModel = NamedGraphItemModel | Record<string, unknown>;
